import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Message} from './message';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class MessagesService {

    private _messagesUrl = '/messagesData';
    private serverURL: string;

    constructor(private http: Http) { 
        this.serverURL = json.api_url;
    }

    getParentMessages():Promise<any> {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }   

        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._messagesUrl + "/parents", options).toPromise().then(res => { 
    
            if (JSON.parse(res.text()).code == 1) {                            
                return JSON.parse(res.text());
            } else {
                return null;
            }            
        
        }, this.handleError);

    }   

    getMessageWithChilds(message: Message) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        const url = `${this._messagesUrl}/${message.id}`;
        let options = new RequestOptions({ headers: authHeader, body: "" });
        
        return this.http.get(this.serverURL + url, options).toPromise().then(result => {
            
            if (JSON.parse(result.text()).code == 1) {
                return JSON.parse(result.text()).rows;
            }        

        }).catch(this.handleError);

    } 

    getMessageById(id: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        const url = `${this._messagesUrl}/parent/${id}`;
        let options = new RequestOptions({ headers: authHeader, body: ""});

        return this.http.get(this.serverURL + url, options).toPromise().then(result => {

            if (JSON.parse(result.text()).code == 1) {
                return JSON.parse(result.text()).rows;
            }

        }).catch(this.handleError);

    }

    putMessagesRead(message: Message) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        const url = `${this._messagesUrl}/${message.id}`;        
        
        return this.http.put(this.serverURL + url, this.serializeObj(message), {headers: authHeader}).toPromise().then(result => {
            
            if (JSON.parse(result.text()).code == 1) {        
                return JSON.parse(result.text()).code;
            }        

        }).catch(this.handleError);

    }

    postMessage(message: Message) {
        
        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        return this.http.post(this.serverURL + this._messagesUrl, this.serializeObj(message), {headers: authHeader}).toPromise().then(result => {
            
            return JSON.parse(result.text());

        }).catch(this.handleError);        

    }

    private handleError(error: any) {
        
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);

    }

    private serializeObj(obj: any) {
        
        var result: any[] = [];
        for (var property in obj) {
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
        }            

        return result.join("&");

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/messages/messages.service.ts
 **/